/**
 * Warehouse Main View
 * Container for Inventory, Requests, and Purchases tabs
 */

const WarehouseView = {
    render() {
        return `
            <div class="view-container warehouse-container wh-view dnr-proposal fade-in">
                <!-- Header -->
                <div class="wh-tabs-row">
                    <h1 class="wh-title">Almacén</h1>
                    <div class="wh-tabs" role="tablist" aria-label="Secciones del almacén">
                        <div class="wh-tab active" data-warehouse-tab="inventory" ${UIEvents.attr("click", function(event,captured){WarehouseView.switchTab('inventory');}, [])}>
                            <i class="fas fa-list"></i> Inventario
                        </div>
                        <div class="wh-tab" data-warehouse-tab="requests" ${UIEvents.attr("click", function(event,captured){WarehouseView.switchTab('requests');}, [])}>
                            <i class="fas fa-hand-holding-box"></i> Solicitudes
                            <span class="wh-tab-count" id="warehouse-requests-badge" style="display:none">0</span>
                        </div>
                        ${AuthManager.isStudent() && AuthManager.canManageWarehouse() ? `<div class="wh-tab" data-warehouse-tab="personal" ${UIEvents.attr('click',()=>WarehouseView.switchTab('personal'))}>Mis solicitudes</div>` : ''}
                        ${AuthManager.canManageWarehouse() || AuthManager.isRRHH() || AuthManager.hasModule('almacen') ? `
                        <div class="wh-tab" data-warehouse-tab="orders" ${UIEvents.attr("click", function(event,captured){WarehouseView.switchTab('orders');}, [])}>
                            <i class="fas fa-shopping-cart"></i> Compras
                        </div>
                        ` : ''}
                        <!-- Admin/Warehouse Only Tabs -->
                        <div class="wh-tab" data-warehouse-tab="import" id="tab-btn-import" ${UIEvents.attr("click", function(event,captured){WarehouseView.switchTab('import');}, [])} style="display:none">
                            <i class="fas fa-file-import"></i> Importar
                        </div>
                        <div class="wh-tab" data-warehouse-tab="assignment" id="tab-btn-assignment" ${UIEvents.attr("click", function(event,captured){WarehouseView.switchTab('assignment');}, [])} style="display:none">
                            <i class="fas fa-tags"></i> Asignar
                        </div>
                    </div>
                    <div class="wh-tabs-row-actions">
                        ${AuthManager.canManageWarehouse() ? `
                        <button type="button" class="btn btn-primary wh-new-btn" ${UIEvents.attr("click", function(event,captured){InventoryList.openAddModal();}, [])}>
                            <i class="fas fa-plus"></i> Nuevo elemento
                        </button>
                        ` : ''}
                    </div>
                </div>

                <div class="wh-tabs-content">
                    <!-- Inventory Tab -->
                    <div id="tab-inventory" class="tab-pane active">
                        <div id="inventory-list-container">
                            <!-- InventoryList.render() will inject here -->
                            <div class="loading-spinner"><i class="fas fa-spinner fa-spin"></i> Cargando inventario...</div>
                        </div>
                    </div>

                    <!-- Requests Tab -->
                    <div id="tab-requests" class="tab-pane">
                        <div id="warehouse-requests-container">
                            <p class="text-muted">Cargando solicitudes...</p>
                        </div>
                    </div>

                    <!-- Orders Tab -->
                    <div id="tab-orders" class="tab-pane">
                        <div id="purchase-orders-container">
                            <p class="text-muted">Cargando órdenes de compra...</p>
                        </div>
                    </div>

                    <!-- Import Tab -->
                    <div id="tab-import" class="tab-pane">
                        <div id="warehouse-import-container"></div>
                    </div>

                    <!-- Assignment Tab -->
                    <div id="tab-assignment" class="tab-pane">
                        <div id="warehouse-assignment-container"></div>
                    </div>
                </div>
            </div>
        `;
    },

    async init() {
        const epoch=AuthManager._epoch;
        const host=document.querySelector('.warehouse-container');
        this._ready=false;
        if(!host)return;
        const content=host.querySelector('.wh-tabs-content');
        SafeHTML.set(content, '<p role="status">Cargando almacén…</p>');
        try { await WarehouseAPI.load(); }
        catch(e) {
            if(epoch===AuthManager._epoch && host.isConnected) SafeHTML.set(content, `<p role="alert">${Utils.sanitizeHTML(e.message)}</p><button class="btn btn-secondary" ${UIEvents.attr("click",()=>App.render())}>Reintentar</button>`);
            return;
        }
        if(epoch!==AuthManager._epoch || !host.isConnected)return;
        SafeHTML.set(host,this.render());
        host.replaceWith(host.firstElementChild);
        this._ready=true;
        console.log('WarehouseView init');

        // Check Access for Students
        if (AuthManager.isStudent() && !AuthManager.canManageWarehouse()) {
            const studentId = AuthManager.getStudentId();
            const students = StudentService.getStudents();

            // Try to find by studentId first, fallback to lookup by username/email for legacy or mock users
            let student = studentId ? StudentService.getStudent(studentId) : null;

            if (!student) {
                const user = AuthManager.getCurrentUser();
                student = students.find(s => s.email === user.username || s.id === user.username);
            }

            // If we can't find the student record, or they don't have access:
            if (!student || !StudentService.hasWarehouseAccess(student.id)) {
                SafeHTML.set(document.querySelector('.warehouse-container'), `
                    <div class="text-center p-5">
                        <i class="fas fa-lock fa-3x text-muted mb-3"></i>
                        <h3>Acceso Restringido</h3>
                        <p>Tu formación no da acceso al almacén.</p>
                        <p class="text-muted small">Si crees que esto es un error, contacta con secretaría. (Alumno: ${Utils.sanitizeHTML(student ? student.firstName : 'No identificado')})</p>
                    </div>
                `);
                return;
            }
        }

        this.switchTab('inventory'); // Load default

        // Initial load of sub-components
        if (typeof InventoryList !== 'undefined') {
            InventoryList.init();
        }

        // Show specialized tabs for Admin/Warehouse
        if (AuthManager.canManageWarehouse()) {
            document.getElementById('tab-btn-import').style.display = 'flex';
            document.getElementById('tab-btn-assignment').style.display = 'flex';
        }
    },

    switchTab(tabName) {
        if(!document.querySelector('.warehouse-container')) return;
        if(this._ready===false)return;
        if(!['inventory','requests','personal','orders','import','assignment'].includes(tabName))return;
        if(['orders','import','assignment'].includes(tabName) && !AuthManager.canManageWarehouse() && !(tabName==='orders'&&(AuthManager.isRRHH()||AuthManager.hasModule('almacen'))))return;
        // Update UI
        document.querySelectorAll('.wh-tab').forEach(t => t.classList.remove('active'));
        const activeTab = document.querySelector(`.wh-tab[data-warehouse-tab="${tabName}"]`);
        if (activeTab) activeTab.classList.add('active');

        document.querySelectorAll('.tab-pane').forEach(p => p.classList.remove('active'));
        const activePane = document.getElementById(`tab-${tabName==='personal'?'requests':tabName}`);
        if (activePane) activePane.classList.add('active');

        // Load content
        if (tabName === 'inventory') {
            if (typeof InventoryList !== 'undefined') {
                SafeHTML.set(document.getElementById('inventory-list-container'), InventoryList.render());
                InventoryList.attachEvents();
            }
        } else if (tabName === 'requests' || tabName === 'personal') {
            if (typeof StudentRequests !== 'undefined') {
                SafeHTML.set(document.getElementById('warehouse-requests-container'), tabName==='personal'?StudentRequests.renderStudentView():StudentRequests.render());
                StudentRequests.init();
            }
        } else if (tabName === 'orders') {
            if (typeof PurchaseManagement !== 'undefined') {
                SafeHTML.set(document.getElementById('purchase-orders-container'), PurchaseManagement.render());
                PurchaseManagement.init();
            }
        } else if (tabName === 'import') {
            if (typeof BulkImport !== 'undefined') {
                SafeHTML.set(document.getElementById('warehouse-import-container'), BulkImport.render());
            }
        } else if (tabName === 'assignment') {
            if (typeof AssignmentManager !== 'undefined') {
                SafeHTML.set(document.getElementById('warehouse-assignment-container'), AssignmentManager.render());
                AssignmentManager.init();
            }
        }
    }
};

// Make globally available
window.WarehouseView = WarehouseView;
